export default {"src":"/_next/static/image/public/images/IC_MALE_GREEN.928c48c61f153d1136bb482a1d3da24c.svg","height":24,"width":25};